import { render, staticRenderFns } from "./AgentsAssignedAndUnavailable.vue?vue&type=template&id=2d65c190"
import script from "./AgentsAssignedAndUnavailable.vue?vue&type=script&lang=js"
export * from "./AgentsAssignedAndUnavailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports